import {Injectable} from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';

@Injectable()
export class NeoBasketService {

    constructor(
        private _rest: NeoRestService) {
    }

    /**
     * Crea un basket
     *
     * @returns {Observable<any>}
     */
    basketCreate() {
        return this._rest.postRaw('/booking');
    }


    /**
     * Añade productos a un basket
     *
     * @returns {Observable<any>}
     */
    add(basketId: string, body) {
        return this._rest.postRaw(`/booking/${basketId}`, body);
    }

    /**
     * Elimina productos de un basket
     *
     * @returns {Observable<any>}
     */
    del(basketId: string, body) {
        return this._rest.postRaw(`/booking/${basketId}/del`, body);
    }

    /**
     * Bloquea la cesta
     *
     * @returns {Observable<any>}
     */
    lockBasket(body) {
        return this._rest.post(`/booking/${body.basketId}/lock`, body);
    }

    /**
     * Desbloquea la cesta
     *
     * @returns {Observable<any>}
     */
    unLockBasket(basketId) {
        return this._rest.get(`/booking/${basketId}/unlock`);
    }

    /**
     * Confirma la cesta
     *
     * @param basketId
     * @param data
     * @returns {Observable<any>}
     */
    confirmBasket(basketId, data) {
        return this._rest.postRaw(`/booking/${basketId}/buy`, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-basket/neo-basket.service.ts